import request from '@/plugins/request';
import utils from '@/utils';
import { API_URL } from '@/const';
import { IUser } from '@/types/models';
import { AxiosResponse } from 'axios';
import { IBoolResult, IStringResult } from '@/types/dto';

const $url = '/login';
const $urlCaptcha = '/login/captcha';
const $urlCaptchaCheck = '/login/captcha/actions/check';
const $urlSendSms = '/login/actions/sendSms';

interface IGetResult {
  isSmsEnabled: boolean;
}

interface ICheckRequest {
  token: string;
  value: string;
}

interface ISubmitRequest {
  isSmsLogin: boolean;
  account: string;
  password: string;
  mobile: string;
  code: string;
}

interface ISubmitResult {
  user: IUser;
  token: string;
}

interface ISendSmsRequest {
  mobile: string;
}

export default {
  getCaptchaUrl(token: string): string {
    return `${API_URL}${$urlCaptcha}?token=${token}`;
  },

  get(success: (res: IGetResult) => void): void {
    utils.loading(true);
    request
      .get($url)
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error, true);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  captchaNew(success: (res: IStringResult) => void): void {
    utils.loading(true);
    request
      .post($urlCaptcha)
      .then((response: AxiosResponse<IStringResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error, true);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  captchaCheck(req: ICheckRequest, success: (res: IBoolResult) => void, failure: () => void): void {
    utils.loading(true);
    request
      .post($urlCaptchaCheck, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error, true);
        failure();
      });
  },

  sendSms(req: ISendSmsRequest, success: (res: IBoolResult) => void): void {
    utils.loading(true);
    request
      .post($urlSendSms, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error, true);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  submit(req: ISubmitRequest, success: (res: ISubmitResult) => void, failure: () => void): void {
    utils.loading(true);
    req.password = utils.md5(req.password);
    request
      .post($url, req)
      .then((response: AxiosResponse<ISubmitResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error, true);
        failure();
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
